import IdleTimer from 'exacta-material-react/lib/src/components/IdleTimer';
import QueryString from 'query-string';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import System from '../../../../config/SystemConfig';
import { IdleTimeout, NotsSystem, S80Tabs } from '../../../../helpers/constants';
import { playerVersion } from '../../../../helpers/utils';
import useReportMonitorReady from '../../../../hooks/useReportMonitorReady';
import { listenInTab_AC, updateExecutionMode_AC } from '../../../../store/actions/executor.actions';
import GuidedContainer from '../../../common-components/GuidedContainer';
import { PauseOverlay } from '../../../common-components/PauseOverlay';
import Knob from './Knob';
import MiniTSD from './MiniTSD';
import NumericKeypad from './NumericKeypad';
import ToggleButton from './ToggleButton';
import TSD from './TSD';

const useStyles = makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    background: `
    linear-gradient(27deg, #151515 5px, transparent 5px) 0 5px,
    linear-gradient(207deg, #151515 5px, transparent 5px) 10px 0px,
    linear-gradient(27deg, #222 5px, transparent 5px) 0px 10px,
    linear-gradient(207deg, #222 5px, transparent 5px) 10px 5px,
    linear-gradient(90deg, #1b1b1b 10px, transparent 10px),
    linear-gradient(#1d1d1d 25%, #1a1a1a 25%, #1a1a1a 50%, transparent 50%, transparent 75%, #242424 75%, #242424)`,
    backgroundColor: `#131313`,
    backgroundSize: `20px 20px`,
    height: `102%`,
  },
  gridContainer: {
    padding: '0.5%',
    width: '1900px',
    // height: '1050px',
  },
  handGripSpace: {
    height: '90%',
    padding: '0',
    borderRadius: '5px',
    background:
      'linear-gradient(to bottom right, rgb(56, 56, 56) 0%, rgb(60, 60, 60) 100%) !important',
    boxShadow: '0 0 10px black',
    margin: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  numpadContainer: {
    marginTop: '50px',
    width: '260px',
  },
  tsdButtonsContainer: {
    height: '160px',
    display: 'flex',
    alignItems: 'center',
  },
  encodersContainer: {
    width: '75%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  tsdContainer: {
    width: '1200px',
    height: '830px',
    marginLeft: '15px',
  },
  tsdAndMiniTsdContainer: {
    display: 'flex',
    width: '100%',
  },
  leftContainer: {
    width: '1580px',
  },
}));

interface IDeskProps {}

const Desk: React.FC<IDeskProps> = () => {
  const [tsdOn, setTsdOn] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { mode } = QueryString.parse(window.location.search);
  const reportMonitorReady = useReportMonitorReady();
  useEffect(() => {
    System.setSystem(NotsSystem.S80).setCurrentTab(S80Tabs.DESK);
  }, []);

  useEffect(() => {
    if (mode) {
      dispatch(updateExecutionMode_AC(`${mode}`));
    }
  }, [mode]);

  useEffect(() => {
    reportMonitorReady('desk');
    dispatch(listenInTab_AC());
  }, []);
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Helmet>
        <title>{`${t('appName')} - Desk ${playerVersion}`}</title>
      </Helmet>
      <PauseOverlay />
      <IdleTimer timeout={IdleTimeout} logoutOnTimeout={false} />
      <GuidedContainer />
      <Grid container spacing={1} className={classes.gridContainer}>
        <div className={classes.leftContainer}>
          <Grid container>
            <Grid item xs={12} className={classes.tsdButtonsContainer}>
              <ToggleButton
                active={tsdOn}
                handleClick={() => setTsdOn(!tsdOn)}
              />
              <div className={classes.encodersContainer}>
                <Knob />
                <Knob />
                <Knob />
                <Knob />
              </div>
            </Grid>
            <div className={classes.tsdAndMiniTsdContainer}>
              <div id="S80_TSD_DEFINITION" className={classes.tsdContainer}>
                <TSD active={tsdOn}></TSD>
              </div>
              <MiniTSD />
            </div>
          </Grid>
        </div>

        <div className={classes.numpadContainer}>
          <NumericKeypad />
        </div>
        {/* <Grid xs={6}>
              <Paper className={classes.handGripSpace}>
                <CornerScrews />
                <CornerScrews />
              </Paper>
            </Grid> */}
      </Grid>
    </div>
  );
};

export default Desk;
